import { useContext, useMemo } from 'react';
import { ForecastFiltersContext } from '../../../state/filters/contexts';
import { size } from 'lodash';

export const FORECAST_EMPTY_STATES_TYPES = {
  MISSING_FILTERS: 'MISSING_FILTERS',
  EMPTY_DATA: 'EMPTY_DATA',
  INSUFFICIENT_LENGTH: 'INSUFFICIENT_LENGTH',
  INSUFFICIENT_SCOPE: 'INSUFFICIENT_SCOPE',
  ENTROPY_HIGH: 'ENTROPY_HIGH',
  PROJECT_COMPLETED: 'PROJECT_COMPLETED',
  NO_CHANCE: 'NO_CHANCE',
  DEFAULT: 'DEFAULT'
};

const NO_CHANCE_THRESHOLD = 0.97;

const useEmptyStateType = ({ forecast }) => {
  const {
    state: { filtersPayload }
  } = useContext(ForecastFiltersContext);

  const errorType = forecast?.errorType;
  const unfinishedProbability = forecast?.unfinished?.probability;

  const emptyStateType = useMemo(() => {
    if (size(filtersPayload) === 0)
      return FORECAST_EMPTY_STATES_TYPES.MISSING_FILTERS;

    if (unfinishedProbability > NO_CHANCE_THRESHOLD)
      return FORECAST_EMPTY_STATES_TYPES.NO_CHANCE;

    if (errorType) {
      return (
        FORECAST_EMPTY_STATES_TYPES[errorType] ||
        FORECAST_EMPTY_STATES_TYPES.DEFAULT
      );
    }

    return null;
  }, [filtersPayload, unfinishedProbability, errorType]);

  return emptyStateType;
};

export default useEmptyStateType;
